import React from "react";
import { Button } from "antd";
import { SummaryRow } from "./SummaryRows";
import { PaymentAmounts } from "./usePaymentAmounts";

// Sticky on desktop, stacked at the foot of the page on mobile.
export default function PaymentSummarySidebar(
  props: {
    paymentInfo: any;
    amounts: PaymentAmounts;
    submitting: boolean;
    onPayNow: () => void;
  }
) {
  const { paymentInfo, amounts, submitting, onPayNow } = props;
  const {
    money, tourPrice, currBalanceAmount, remainingAfterDeposit,
    payingNow, currPayingNow, balanceAfterPayment, currBalanceAfterPayment,
    payingDeposit, nothingSelected,
  } = amounts;

  return (
    <div className="payment-layout_summary">
      <div style={{ background: "#fff", borderLeft: "4px solid #DC1A22", borderRadius: 12, padding: 20, boxShadow: "0px 5px 20px 0px rgba(0,0,0,0.15)" }}>
        <h3 style={{ marginBottom: 16, fontSize: 16, fontWeight: 700 }}>Summary</h3>

        <SummaryRow label="Package" value={paymentInfo.code} />
        <SummaryRow label="Tour price" value={money(tourPrice, tourPrice)} />

        {payingDeposit ? (
          <>
            <SummaryRow
              label="Remaining balance"
              value={money(remainingAfterDeposit, currBalanceAmount)}
              valueStyle={{ color: "#DC1A22", fontWeight: 600 }}
            />
            {paymentInfo.payment_deadline && (
              <SummaryRow label="Final payment due" value={paymentInfo.payment_deadline} />
            )}
          </>
        ) : (
          <SummaryRow
            label="Balance after payment"
            value={money(balanceAfterPayment, currBalanceAfterPayment)}
            valueStyle={balanceAfterPayment > 0
              ? { color: "#DC1A22", fontWeight: 600 }
              : { color: "#52C41A", fontWeight: 600 }}
          />
        )}

        <div style={{ marginTop: 10, marginBottom: 4, fontSize: 13, color: "#8c8c8c" }}>Paying now</div>
        <div style={{ color: "#DC1A22", fontSize: 24, fontWeight: 700, marginBottom: 16 }}>
          {money(payingNow, currPayingNow)}
        </div>

        <Button
          className="pay-now-button"
          color="primary"
          variant="solid"
          block
          loading={submitting}
          disabled={nothingSelected}
          onClick={onPayNow}
        >
          Pay now
        </Button>

        <p style={{ fontSize: 12, color: "#888", marginTop: 12, lineHeight: 1.5 }}>
          Your payment is encrypted and processed securely. We do not store your card details.
        </p>
      </div>
    </div>
  );
}
